import { config } from "./config";
import axios from "axios";
import utils from "../utils";

let taskApi = {};

taskApi.getGraphData = (chartTime) => {
  return axios.post(`${config.url}/${utils.fetchVariable("current_team")}/task/graph`, {
    period:chartTime
  }, {
    headers: {
      BotzaToken: utils.fetchToken(),
    },
  });
};

taskApi.getStats = () => {

  return axios.get(`${config.url}/${utils.fetchVariable("current_team")}/task/stats`, {
    headers: {
      BotzaToken: utils.fetchToken(),
    },
  });
};

taskApi.getList = (data) => {
  const formData = {}
    if (data) {
    data.forEach((ob) => {
      formData[ob.key]= ob.value;
    });
  }

  formData.limit=10;
  formData.sort_by="ID";
  formData.sort_order="DESC";
  return axios.post(`${config.url}/${utils.fetchVariable("current_team")}/task/list`, formData, {
    headers: {
      BotzaToken: utils.fetchToken(),
    },
  });
};

taskApi.getCategories = () => {
  return axios.get(`${config.url}/${utils.fetchVariable("current_team")}/tasks/category/list`, {
    headers: {
      BotzaToken: utils.fetchToken(),
    },
  });
};

taskApi.getTags = () => {

  return axios.get(`${config.url}/${utils.fetchVariable("current_team")}/task/tag/list`, {
    headers: {
      BotzaToken: utils.fetchToken(),
    },
  });
};

taskApi.addtask = (data) => {
  const formData = {};

  Object.keys(data).forEach((key) => {
    formData[key]= data[key];
  });

  return axios.post(`${config.url}/${utils.fetchVariable("current_team")}/task/create`, formData, {
    headers: {
      BotzaToken: utils.fetchToken(),
    },
  });
};

taskApi.editTask = (data) => {
  const formData = {};

  Object.keys(data).forEach((key) => {
    if(key != "task_id"){
      formData[key]= data[key];
    }
  });


  return axios.post(`${config.url}/${utils.fetchVariable("current_team")}/task/${data.task_id}/update`, formData, {
    headers: {
      BotzaToken: utils.fetchToken(),
    },
  });
};

taskApi.pinTask = (task_id) => {
  return axios.post(`${config.url}/${utils.fetchVariable("current_team")}/task/${task_id}/update`, {"pinned":"on"}, {
    headers: {
      BotzaToken: utils.fetchToken(),
    },
  });
};

taskApi.detachTask = (task_id) => {
  return axios.post(`${config.url}/${utils.fetchVariable("current_team")}/task/${task_id}/update`, {"pinned":"off"}, {
    headers: {
      BotzaToken: utils.fetchToken(),
    },
  });
};

taskApi.deleteTask = (task_id) => {
  return axios.get(`${config.url}/${utils.fetchVariable("current_team")}/task/${task_id}/delete`, {
    headers: {
      BotzaToken: utils.fetchToken(),
    },
  });
};

taskApi.addComment = (task_id, commentText) => {
  const formData = {}
  formData.text= commentText;
  return axios.post(`${config.url}/${utils.fetchVariable("current_team")}/task/${task_id}/comment/add`, formData, {
    headers: {
      BotzaToken: utils.fetchToken(),
    },
  });
};

taskApi.removeComment = (task_id, commentId) => {
  return axios.get(`${config.url}/${utils.fetchVariable("current_team")}/task/${task_id}/comment/${commentId}/delete`, {
    headers: {
      BotzaToken: utils.fetchToken(),
    },
  });
};

taskApi.addAttachment = (task_id, file) => {
  const formData = new FormData();

  file.forEach((fileInfo) => {
    formData.append("file[]", fileInfo);
  });

  return axios.post(`${config.url}/${utils.fetchVariable("current_team")}/task/${task_id}/attachment`, formData, {
    headers: {
      BotzaToken: utils.fetchToken(),
    },
  });
};

taskApi.fetchTaskAttachments = (task_id) => {
  return axios.get(`${config.url}/${utils.fetchVariable("current_team")}/task/${task_id}/attachment/list`, {
    headers: {
      BotzaToken: utils.fetchToken(),
    },
  });
};


taskApi.fetchTaskComments = (task_id) => {
  return axios.get(`${config.url}/${utils.fetchVariable("current_team")}/task/${task_id}/comment/list`, {
    headers: {
      BotzaToken: utils.fetchToken(),
    },
  });
};
export default taskApi;
